export const DEV_ENV = process.env.NODE_ENV === "development";
